import { render, staticRenderFns } from "./ResultCard.vue?vue&type=template&id=52d2be14&scoped=true"
import script from "./ResultCard.vue?vue&type=script&lang=js"
export * from "./ResultCard.vue?vue&type=script&lang=js"
import style0 from "./ResultCard.vue?vue&type=style&index=0&id=52d2be14&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d2be14",
  null
  
)

export default component.exports